import { useContext, useMemo } from 'react'
import { SUPPORT_EMAIL } from '../../config'
import { getSettingsAdminInfo, getSettingsIndexConfig } from '../../services/settings-config'
import { userHasGroup } from "../../services/utils"

import { formatPhoneNumber, getScoutContext } from '../../services/scout'
import {
    AlternateEmailOutlined as AlternateEmailOutlinedIcon,
    BadgeOutlined as BadgeOutlinedIcon,
    ChevronRight as ChevronRightIcon,
    CreditCardOutlined as CreditCardOutlinedIcon,
    ContactPhoneOutlined as ContactPhoneOutlinedIcon,
    Inventory2Outlined as Inventory2OutlinedIcon,
    PhoneIphoneOutlined as PhoneIphoneOutlinedIcon,
    SettingsSuggestOutlined as SettingsSuggestOutlinedIcon,
    SupportAgentOutlined as SupportAgentOutlinedIcon,
    VisibilityOutlined as VisibilityOutlinedIcon,
    AdminPanelSettings as AdminPanelSettingsIcon,
    AssessmentOutlined as AssessmentOutlinedIcon,
} from '@mui/icons-material'

import { settingsContext } from '.'

const getSettingsCardIcon = (id) => {
    switch (id) {
        case "phones": return <ContactPhoneOutlinedIcon />
        case "admins": return <AdminPanelSettingsIcon />
        case "payments": return <CreditCardOutlinedIcon />
        case "restricted": return <VisibilityOutlinedIcon />
        case "reports": return <AssessmentOutlinedIcon />
        default: return <Inventory2OutlinedIcon />
    }
}

const SettingsBase = () => {

    const { changeLocation } = useContext(settingsContext)
    const { user } = getScoutContext()
    const adminInfo = useMemo(() => getSettingsAdminInfo(user), [user])
    const indexConfig = useMemo(() => getSettingsIndexConfig(), [])

    return (
        <>
            <section className="scout-settings-section">
                <div className="scout-settings-section__label">
                    <BadgeOutlinedIcon />
                    <span>{'Dados do administrador'}</span>
                </div>

                <div className="scout-settings-card scout-settings-card--stacked">
                    <div className="scout-settings-info-row">
                        <BadgeOutlinedIcon />
                        <div>
                            <span>Nome</span>
                            <strong>{adminInfo.name}</strong>
                        </div>
                    </div>
                    <div className="scout-settings-info-row">
                        <AlternateEmailOutlinedIcon />
                        <div>
                            <span>E-mail</span>
                            <strong>{adminInfo.email}</strong>
                        </div>
                    </div>
                    <div className="scout-settings-info-row">
                        <PhoneIphoneOutlinedIcon />
                        <div>
                            <span>Telefone</span>
                            <strong>{formatPhoneNumber(adminInfo.phone)}</strong>
                        </div>
                    </div>
                </div>

                <div className="scout-settings-inline-cta">
                    <p>{adminInfo.supportPrompt}</p>
                    <button
                        type="button"
                        className="scout-settings-support-button"
                        onClick={() => window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Suporte%20Kwik%20Scout`}
                    >
                        <SupportAgentOutlinedIcon />
                        <span>{adminInfo.supportCta}</span>
                        <ChevronRightIcon />
                    </button>
                </div>
            </section>

            <section className="scout-settings-section">
                <div className="scout-settings-section__label">
                    <SettingsSuggestOutlinedIcon />
                    <span>{indexConfig?.otherSectionLabel || 'Outras configurações'}</span>
                </div>

                <div className="scout-settings-card scout-settings-card--menu">
                    {(indexConfig?.cards || []).map((item) => (
                        userHasGroup(item.groups) && (
                            <button key={item.id} type="button" className="scout-settings-menu-row" onClick={() => changeLocation(item.path)}>
                                {getSettingsCardIcon(item.id)}
                                <span>{item.label}</span>
                                <ChevronRightIcon />
                            </button>
                        )
                    ))}
                </div>
            </section>
        </>
    )
}

export default SettingsBase